(function () {
'use strict';
var W = window, D = document, I = W.__toestemming;
if (!I || typeof I !== 'object') return;
var EU = 'AT BE BG HR CY CZ DK EE FI FR DE GR HU IE IT LV LT LU MT NL PL PT RO SK SI ES SE IS LI NO GB CH'.split(' ');
var T = I.teksten || {}, host, stand, S, land = '', cookie = null, wortel, venster, widget, gegeven = {}, teller = {}, telT, vorm = null, terug = null, cssKlaar = false, getoond = false, keus = null;
function esc(s) { return String(s == null ? '' : s).replace(/[&<>"]/g, function (c) { return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;' }[c]; }); }
function tx(k, v) { var s = T[k] != null ? T[k] : k; if (v) for (var n in v) s = s.split('{' + n + '}').join(v[n]); return s; }
function uuid() {
try { return crypto.randomUUID(); } catch (e) {}
var h = '0123456789abcdef', s = '';
for (var i = 0; i < 36; i++) s += (i == 8 || i == 13 || i == 18 || i == 23) ? '-' : i == 14 ? '4' : i == 19 ? h[(Math.random() * 4 | 0) + 8] : h[Math.random() * 16 | 0];
return s;
}
function leesCookie() {
var m = D.cookie.match(/(?:^|; )toestemming=([^;]*)/);
if (!m) return null;
try { var c = JSON.parse(decodeURIComponent(m[1])); return c && c.v === 1 && typeof c.c === 'string' && c.id ? c : null; } catch (e) { return null; }
}
function zetCookie(c) { D.cookie = 'toestemming=' + encodeURIComponent(JSON.stringify(c)) + '; Max-Age=31536000; Path=/; SameSite=Lax; Secure'; }
function cats(c) { return { a: c.indexOf('a') > -1, m: c.indexOf('m') > -1 }; }
function gtag() { W.dataLayer = W.dataLayer || []; W.dataLayer.push(arguments); }
function dl(o) { W.dataLayer = W.dataLayer || []; W.dataLayer.push(o); }
function evt(n, d) { try { W.dispatchEvent(new CustomEvent(n, { detail: d })); } catch (e) {} }
function fout(e) { try { tel('script_fout'); if (wortel && wortel.parentNode) wortel.parentNode.removeChild(wortel); if (W.console) console.error('[toestemming]', e); } catch (x) {} }
function datum(iso, metTijd) {
try { var o = { day: '2-digit', month: '2-digit', year: 'numeric' }; if (metTijd) { o.hour = '2-digit'; o.minute = '2-digit'; } return new Intl.DateTimeFormat(I.taal || 'nl', o).format(new Date(iso)); } catch (e) { return iso; }
}
function tel(n) { if (!I.ontvanger || I.test) return; teller[n] = (teller[n] || 0) + 1; clearTimeout(telT); telT = setTimeout(stuurTelling, 2000); }
function stuurTelling() {
var m = teller; teller = {}; clearTimeout(telT);
for (var k in m) { try { navigator.sendBeacon(I.ontvanger + '/v1/telling', new Blob([JSON.stringify({ winkel: I.winkel, domein: host, metrieken: m })], { type: 'text/plain' })); } catch (e) {} return; }
}
function wacht() { try { return JSON.parse(localStorage.getItem('toestemming_wacht') || '[]'); } catch (e) { return []; } }
function bewaar(q) { try { if (q.length) localStorage.setItem('toestemming_wacht', JSON.stringify(q.slice(-20))); else localStorage.removeItem('toestemming_wacht'); } catch (e) {} }
function register(r) { var q = wacht(); q.push(r); bewaar(q); verzend(); }
function verwijder(id) { bewaar(wacht().filter(function (x) { return x.id !== id; })); }
function verzend() {
var q = wacht(); if (!q.length || !I.ontvanger || !W.fetch) return;
q.forEach(function (r) { r.n = (r.n || 0) + 1; });
bewaar(q.filter(function (r) { return r.n <= 6; }));
q.forEach(function (r) {
if (r.n > 6) return;
var b = {}; for (var k in r) if (k !== 'n') b[k] = r[k];
try {
fetch(I.ontvanger + '/v1/keuze', { method: 'POST', keepalive: true, body: JSON.stringify(b), headers: { 'Content-Type': 'text/plain' } })
.then(function (a) { if (a.ok || (a.status >= 400 && a.status < 500 && a.status !== 429)) verwijder(r.id); }, function () {});
} catch (e) {}
});
}
D.addEventListener('visibilitychange', function () { if (D.visibilityState === 'hidden') stuurTelling(); });
W.addEventListener('pagehide', stuurTelling);
function familie(p, k) {
dl({ event: 'consent-studio__' + p });
dl({ event: 'consent-studio__' + p + '__' + (k.a ? 'granted' : 'denied') + '-analytics' });
dl({ event: 'consent-studio__' + p + '__' + (k.m ? 'granted' : 'denied') + '-marketing' });
if (k.a && k.m) dl({ event: 'consent-studio__' + p + '__granted-all' });
if (!k.a && !k.m) dl({ event: 'consent-studio__' + p + '__denied-all' });
}
function signalen(c, modus, via, vorigC) {
var k = cats(c), g = 'granted', d = 'denied', a = k.a ? g : d, m = k.m ? g : d;
var lijst = ['functional'].concat(k.a ? ['analytics'] : [], k.m ? ['marketing'] : []);
if (modus !== 'laad' || !I.kop) gtag('consent', 'update', { ad_storage: m, ad_user_data: m, ad_personalization: m, analytics_storage: a, functionality_storage: g, personalization_storage: g, security_storage: g });
W.uetq = W.uetq || []; W.uetq.push('consent', 'update', { ad_storage: m, ad_user_data: m });
if (modus === 'keuze' || modus === 'herstel' || modus === 'buiten') {
try {
var P = W.Shopify && W.Shopify.customerPrivacy, cv = modus === 'buiten' && P && P.currentVisitorConsent ? P.currentVisitorConsent() : null;
if (P && P.setTrackingConsent && !(cv && cv.analytics === 'yes' && cv.marketing === 'yes')) P.setTrackingConsent({ preferences: true, analytics: k.a, marketing: k.m, sale_of_data: k.m }, function () {});
} catch (e) {}
}
gtag('event', 'cookie_consent_update');
W.uetq.push('event', 'cookie_consent_update', { event_category: 'consent_studio' });
lijst.forEach(function (x) { if (!gegeven[x]) { gegeven[x] = 1; gtag('event', 'cookie_consent_granted_' + x); } });
if (modus === 'keuze') familie('user-interacted__modal', k);
familie('parsed-consent', k);
var bron = modus === 'keuze' ? 'interactive' : 'api';
if (modus !== 'laad') {
var v = cats(vorigC || 'f');
if (v.a !== k.a) evt('consent-studio__updated__' + (k.a ? 'granted' : 'denied') + '__analytics', { category: 'analytics' });
if (v.m !== k.m) evt('consent-studio__updated__' + (k.m ? 'granted' : 'denied') + '__marketing', { category: 'marketing' });
dl({ event: 'consent-studio__updated', categories: lijst, source: bron });
evt('consent-studio__updated', { categories: lijst, source: bron });
}
evt('toestemming', { functioneel: true, analytics: k.a, marketing: k.m, via: via || modus, id: cookie ? cookie.id : null, stand: S, land: land, bron: modus });
startScripts(k);
}
function startScripts(k) {
var ss = D.querySelectorAll('script[type="text/plain"][data-toestemming]');
for (var i = 0; i < ss.length; i++) {
var s = ss[i], c = s.getAttribute('data-toestemming');
if (s.__tst || !(c === 'functioneel' || (c === 'analytics' && k.a) || (c === 'marketing' && k.m))) continue;
s.__tst = 1; var n = D.createElement('script');
for (var j = 0; j < s.attributes.length; j++) { var at = s.attributes[j]; if (at.name !== 'type') n.setAttribute(at.name, at.value); }
if (s.src) n.src = s.src; else n.text = s.textContent;
s.parentNode.insertBefore(n, s.nextSibling);
}
}
function wisTracking() {
var vast = ' _ga _gid _gat _fbp _fbc _ttp _tt_enable_cookie _scid _scid_r _sctr __kla_id _pin_unauth _uetsid _uetvid ';
D.cookie.split('; ').forEach(function (p) {
var nm = p.split('=')[0];
if (vast.indexOf(' ' + nm + ' ') > -1 || /^(_ga_|_gcl_|_hj|ttcsid|_scid)/.test(nm)) {
var ex = nm + '=; Max-Age=0; Path=/';
D.cookie = ex; D.cookie = ex + '; Domain=' + host; D.cookie = ex + '; Domain=.' + host;
}
});
try { localStorage.removeItem('_gcl_ls'); } catch (e) {}
}
function keuze(c, via, bron) {
var vorig = cookie ? cookie.id : null, vorigC = cookie ? cookie.c : null, k = cats(c);
cookie = { v: 1, c: c, t: new Date().toISOString().replace(/\.\d+Z$/, 'Z'), id: uuid(), b: I.banner_versie || '', l: I.lijst_versie || '', s: S === 'kruisje' ? 'k' : 'w' };
zetCookie(cookie);
if (via === 'intrekken') wisTracking();
signalen(c, via === 'herstel' || via === 'gpc' ? 'herstel' : 'keuze', via, vorigC);
register({ id: cookie.id, winkel: I.winkel, domein: host, land: land || null, taal: I.taal || null, pagina: location.pathname, stand: S, f: true, a: k.a, m: k.m, via: via, vorige_id: vorig, bv: I.banner_versie || null, lv: I.lijst_versie || null, bron: bron || 'banner', test: !!I.test });
tel(via === 'alles' ? 'keuze_alles' : via === 'selectie' ? 'keuze_selectie' : via === 'herstel' ? 'herstel_safari' : 'keuze_weiger');
sluit(); maakWidget();
}
function laadCss(cb) {
if (cssKlaar || !I.css) return cb();
var l = D.createElement('link'), k = false; l.rel = 'stylesheet'; l.href = I.css;
function klaar() { if (!k) { k = true; cssKlaar = true; cb(); } }
l.onload = klaar; l.onerror = klaar; D.head.appendChild(l); setTimeout(klaar, 1200);
}
function icoon(id) {
var s = I.stijl || {}, i = s.icoon;
if (i && /^<svg/i.test(i)) return i;
var k1 = s.icoon_kleur1 || s.accent1 || '#F39030', k2 = s.icoon_kleur2 || s.accent2 || '#EC6919';
return '<svg width="18" height="18" viewBox="0 0 24 24" aria-hidden="true"><defs><linearGradient id="tstk' + id + '" x1="0" y1="0" x2="24" y2="0" gradientUnits="userSpaceOnUse"><stop offset="0" stop-color="' + esc(k1) + '"/><stop offset="1" stop-color="' + esc(k2) + '"/></linearGradient><mask id="tsth' + id + '"><rect width="24" height="24" fill="#fff"/><circle cx="21" cy="4" r="5" fill="#000"/></mask></defs><circle cx="12" cy="12" r="10.5" fill="url(#tstk' + id + ')" mask="url(#tsth' + id + ')"/><g fill="#fff"><circle cx="8" cy="9" r="1.5"/><circle cx="14" cy="14.5" r="1.6"/><circle cx="8.5" cy="16" r="1.2"/><circle cx="13" cy="8" r="1"/><circle cx="17.5" cy="12" r="1"/></g></svg>';
}
var SVG = {
lijst: '<svg width="15" height="15" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" aria-hidden="true"><path d="M4 7h16M4 12h16M4 17h16"/></svg>',
x: '<svg width="15" height="15" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.2" stroke-linecap="round" aria-hidden="true"><path d="M6 6l12 12M18 6L6 18"/></svg>',
kopie: '<svg width="13" height="13" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" aria-hidden="true"><rect x="8" y="8" width="12" height="12" rx="2"/><path d="M16 8V5a1 1 0 0 0-1-1H5a1 1 0 0 0-1 1v10a1 1 0 0 0 1 1h3"/></svg>',
vink: '<svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="M3 6l2 2 3-3M3 13l2 2 3-3M11 7h10M11 14h10M11 20h10M3 20h4"/></svg>',
koek: '<svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="M21 12.5A9 9 0 1 1 11.5 3a3 3 0 0 0 3.5 3.5 3 3 0 0 0 3.5 3.5 3 3 0 0 0 2.5 2.5z"/><circle cx="8.5" cy="10.5" r="1"/><circle cx="14" cy="15" r="1"/><circle cx="9" cy="16" r="1"/></svg>'
};
function font(f, val) { f = String(f || val); return /[,'"]|^var\(/.test(f) ? f : "'" + f + "', " + (/garamond|serif/i.test(f) && !/sans/i.test(f) ? 'serif' : 'sans-serif'); }
function stijl() {
var s = I.stijl || {}, v = {
'--tst-a1': s.accent1 || '#FD9227', '--tst-a2': s.accent2 || '#EC691A', '--tst-tekst': s.tekst || '#333', '--tst-titel': s.titel || '#1A1A1A',
'--tst-bg': s.achtergrond || '#fff', '--tst-font': font(s.lettertype, 'Poppins'), '--tst-font-titel': font(s.lettertype_titel || s.lettertype, 'Poppins'),
'--tst-radius': /^[\d.]+$/.test(String(s.radius || '')) ? s.radius + 'px' : (s.radius || '7.5px'), '--tst-knop-tekst': s.knop_tekst || '#fff',
'--tst-titel-grootte': /^[\d.]+$/.test(String(s.titel_grootte || '')) ? s.titel_grootte + 'px' : (s.titel_grootte || '15px'),
'--tst-titel-gewicht': /^[1-9]00$/.test(String(s.titel_gewicht || '')) ? s.titel_gewicht : '600',
'--tst-titel-spatie': s.titel_spatiering || '.2px'
}, uit = '';
for (var k in v) uit += k + ':' + String(v[k]).replace(/[;{}]/g, '') + ';';
return uit;
}
function schakelaar(c, aan, vast) {
return '<label class="tst-sw' + (vast ? ' tst-vast' : '') + '"><input type="checkbox" data-c="' + c + '"' + (aan ? ' checked' : '') + (vast ? ' disabled' : '') + '><span class="tst-baan"><span class="tst-knop"></span></span>' + esc(tx(c === 'a' ? 'analytics' : c === 'm' ? 'marketing' : 'functioneel')) + '</label>';
}
function knoppenHtml(heropend) {
var sel = '<button type="button" class="tst-btn tst-btn2" data-a="selectie">' + esc(tx(heropend ? 'selectie_opslaan' : 'accepteer_selectie')) + '</button>';
var alles = '<button type="button" class="tst-btn tst-btn1" data-a="alles">' + esc(tx('accepteer_alles')) + '</button>';
if (S === 'kruisje') return '<div class="tst-knoppen">' + sel + alles + '</div>';
return '<div class="tst-knoppen tst-drie"><button type="button" class="tst-btn tst-btn1" data-a="weiger">' + esc(tx('weiger_alles')) + '</button>' + sel + alles + '</div>';
}
function bannerHtml(heropend, c) {
var k = cats(c || 'f'), tekst = esc(tx('tekst')).replace(/\[([^\]]+)\]/, '<a href="' + esc(I.privacy || '/policies/privacy-policy') + '" target="_blank" rel="noopener">$1</a>');
return '<div class="tst-paneel tst-banner">' +
'<div class="tst-kop"><p class="tst-titel" id="tst-titel">' + icoon('b') + esc(tx('titel')) + '</p>' +
'<button type="button" class="tst-act tst-ov" data-a="overzicht" aria-label="' + esc(tx('overzicht')) + '">' + SVG.lijst + '<span>' + esc(tx('overzicht')) + '</span></button>' +
'<button type="button" class="tst-act tst-x" data-a="x" aria-label="' + esc(tx(heropend ? 'sluiten_ongewijzigd' : 'sluiten_weiger')) + '">' + SVG.x + '</button></div>' +
'<p class="tst-tekst" id="tst-tekst">' + tekst + '</p>' +
'<div class="tst-schak">' + schakelaar('f', true, true) + schakelaar('a', k.a) + schakelaar('m', k.m) + '</div>' + knoppenHtml(heropend) + '</div>';
}
function statusHtml() {
var k = cats(cookie.c), voor = [tx('functioneel')].concat(k.a ? [tx('analytics')] : [], k.m ? [tx('marketing')] : []);
var lijst = voor.length > 1 ? voor.slice(0, -1).join(', ') + ' ' + tx('en') + ' ' + voor[voor.length - 1] : voor[0];
var tot = new Date(new Date(cookie.t).getTime() + 365 * 864e5).toISOString();
return '<div class="tst-paneel tst-status"><div class="tst-kop"><p class="tst-titel tst-titel2">' + esc(tx('jouw_toestemming')) + '</p><button type="button" class="tst-act tst-rood" data-a="intrekken">' + esc(tx('intrekken')) + '</button></div>' +
'<dl class="tst-dl"><dt>' + esc(tx('id')) + '</dt><dd><span class="tst-mono">' + esc(cookie.id) + '</span> <button type="button" class="tst-kopie" data-a="kopie" aria-label="' + esc(tx('id_kopieren')) + '">' + SVG.kopie + '</button></dd>' +
'<dt>' + esc(tx('gegeven_voor')) + '</dt><dd>' + esc(lijst) + '</dd><dt>' + esc(tx('datum')) + '</dt><dd>' + esc(datum(cookie.t, true)) + '</dd>' +
'<dt>' + esc(tx('geldig_tot')) + '</dt><dd>' + esc(datum(tot)) + ', ' + esc(tx('geldig_tot_na')) + '</dd></dl></div>';
}
var lijst = I.cookies ? normaliseer(I.cookies) : null;
function normaliseer(cs) {
var t = I.taal || 'nl';
return cs.map(function (c) {
var d = c.duur, o = c.omschrijving;
return { naam: c.naam, partij: c.partij, categorie: c.categorie, soort: c.soort,
duur: typeof d === 'object' && d ? (d[t] || d.nl || '') : (d || ''),
omschrijving: typeof o === 'object' && o ? (o[t] || o.en || o.nl || '') : (o || '') };
});
}
function laadLijst() {
if (lijst || !I.lijst || !W.fetch) { if (!lijst) lijst = []; return; }
fetch(I.lijst).then(function (r) { return r.json(); }).then(function (j) { lijst = normaliseer(j.cookies || []); if (vorm === 'overzicht') toon('overzicht', terug); },
function () { lijst = []; if (vorm === 'overzicht') toon('overzicht', terug); });
}
function overzichtHtml() {
var groepen = { functioneel: {}, analytics: {}, marketing: {} }, partijen = I.partijen || {};
(lijst || []).forEach(function (c) { var g = groepen[c.categorie] || groepen.functioneel; (g[c.partij] = g[c.partij] || []).push(c); });
var h = '<div class="tst-paneel tst-overzicht"><div class="tst-kop"><p class="tst-titel tst-titel2" id="tst-ov-titel">' + esc(tx('overzicht')) + '</p><button type="button" class="tst-act tst-x" data-a="ov-sluit" aria-label="' + esc(tx('overzicht_sluiten')) + '">' + SVG.x + '</button></div><div class="tst-scroll">';
if (!lijst) return h + '<p class="tst-uitleg">…</p></div></div>';
['functioneel', 'analytics', 'marketing'].forEach(function (cat) {
var g = groepen[cat], namen = Object.keys(g);
h += '<p class="tst-cat">' + esc(tx(cat === 'marketing' ? 'marketing_overzicht' : cat)) + '</p><p class="tst-uitleg">' + esc(tx('uitleg_' + cat)) + '</p><div class="tst-lijst">';
if (!namen.length) h += '<p class="tst-uitleg">' + esc(tx('geen')) + '</p>';
namen.forEach(function (p, i) {
var items = g[p], pu = (partijen[p] && partijen[p].privacy) || (p === I.winkel ? I.privacy : '');
h += '<button type="button" class="tst-rij" data-a="partij" aria-expanded="false"><span>' + esc(p) + '</span><span class="tst-tel">' + items.length + '</span></button><div class="tst-items" hidden>';
items.forEach(function (c) {
h += '<div class="tst-item"><p class="tst-naam">' + esc(c.naam) + '</p><span>' + esc(c.omschrijving || '') + '</span><div class="tst-meta"><span>' + esc(tx(c.soort === 'opslag' ? 'soort_opslag' : c.soort === 'pixel' ? 'soort_pixel' : 'soort_cookie')) + '</span><span>' + esc(c.duur || '') + '</span><span>' + esc(c.partij) + '</span></div></div>';
});
if (pu) h += '<p class="tst-pl"><a href="' + esc(pu) + '" target="_blank" rel="noopener">' + esc(tx('privacy_van', { partij: p })) + '</a></p>';
h += '</div>';
});
h += '</div>';
});
return h + '</div></div>';
}
function maakWortel() {
if (wortel) return;
wortel = D.createElement('div'); wortel.id = 'tst'; wortel.className = 'tst'; wortel.setAttribute('style', stijl()); wortel.setAttribute('data-stand', S);
try { var pb = D.getElementById('PBarNextFrame'); if (pb) { var ph = pb.getBoundingClientRect().height; wortel.style.setProperty('--tst-onder', (ph > 200 ? 60 : Math.round(ph)) + 'px'); } } catch (e) {}
D.body.appendChild(wortel);
wortel.addEventListener('click', klik); wortel.addEventListener('change', wissel); wortel.addEventListener('keydown', toets);
}
function maakWidget() {
if (widget || !cookie) return;
maakWortel();
widget = D.createElement('div'); widget.className = 'tst-widget';
widget.innerHTML = '<button type="button" class="tst-wg" data-a="voorkeuren" aria-label="' + esc(tx('widget_voorkeuren')) + '">' + SVG.vink + '</button><button type="button" class="tst-wg" data-a="w-overzicht" aria-label="' + esc(tx('widget_overzicht')) + '">' + SVG.koek + '</button>';
wortel.appendChild(widget);
}
function toon(welke, naarTerug) {
laadCss(function () {
maakWortel();
if (!venster) { venster = D.createElement('div'); venster.className = 'tst-venster'; venster.setAttribute('role', 'dialog'); venster.setAttribute('aria-modal', 'true'); venster.tabIndex = -1; wortel.appendChild(venster); }
if (welke === 'overzicht' && vorm && vorm !== 'overzicht') keus = selectie();
vorm = welke; terug = naarTerug || null;
if (welke === 'overzicht') { if (!lijst) laadLijst(); venster.innerHTML = overzichtHtml(); venster.setAttribute('aria-labelledby', 'tst-ov-titel'); venster.removeAttribute('aria-describedby'); }
else { venster.innerHTML = bannerHtml(welke === 'heropend', keus || (cookie ? cookie.c : 'f')) + (welke === 'heropend' ? statusHtml() : ''); keus = null; venster.setAttribute('aria-labelledby', 'tst-titel'); venster.setAttribute('aria-describedby', 'tst-tekst'); }
venster.hidden = false; wortel.setAttribute('data-open', welke);
var f = venster.querySelector(welke === 'overzicht' ? '.tst-act' : 'input:not([disabled])'); if (f) f.focus({ preventScroll: true });
if (welke === 'banner' && !getoond) { getoond = true; tel('banner_getoond'); }
if (welke === 'heropend') dl({ event: 'consent-studio__user-interacted__open-consent-banner' });
if (welke === 'overzicht') dl({ event: 'consent-studio__user-interacted__open-tracking-overview' });
});
}
function sluit() { if (venster) { venster.hidden = true; venster.innerHTML = ''; } vorm = null; keus = null; if (wortel) wortel.removeAttribute('data-open'); }
function selectie() { var c = 'f', ii = venster ? venster.querySelectorAll('input[data-c]') : []; for (var i = 0; i < ii.length; i++) if (ii[i].checked && ii[i].getAttribute('data-c') !== 'f') c += ii[i].getAttribute('data-c'); return c; }
function wissel(e) { var i = e.target; if (i.getAttribute && i.getAttribute('data-c') && i.getAttribute('data-c') !== 'f') dl({ event: 'consent-studio__user-interacted__modal__toggled-' + (i.getAttribute('data-c') === 'a' ? 'analytics' : 'marketing') }); }
function klik(e) {
var b = e.target.closest ? e.target.closest('[data-a]') : null; if (!b) return;
var a = b.getAttribute('data-a');
try {
if (a === 'alles') { dl({ event: 'consent-studio__user-interacted__btn__accept-all' }); keuze('fam', 'alles'); }
else if (a === 'selectie') { var c = selectie(); dl({ event: 'consent-studio__user-interacted__btn__accept-selection', categories: ['functional'].concat(c.indexOf('a') > -1 ? ['analytics'] : [], c.indexOf('m') > -1 ? ['marketing'] : []) }); keuze(c, 'selectie'); }
else if (a === 'weiger') { dl({ event: 'consent-studio__user-interacted__btn__reject-all' }); keuze('f', 'weigerknop'); }
else if (a === 'x') { if (vorm === 'heropend') { dl({ event: 'consent-studio__user-interacted__btn__hide-consent-banner' }); sluit(); } else { dl({ event: 'consent-studio__user-interacted__btn__reject-all' }); keuze('f', 'kruisje'); } }  // zoals Consent Studio: kruisje = reject-all (naast elkaar gemeten)
else if (a === 'overzicht') { dl({ event: 'consent-studio__user-interacted__btn__customise' }); toon('overzicht', vorm); }
else if (a === 'ov-sluit') { if (terug) toon(terug); else sluit(); }
else if (a === 'partij') { var it = b.nextElementSibling, open = b.getAttribute('aria-expanded') === 'true'; b.setAttribute('aria-expanded', !open); it.hidden = open; b.classList.toggle('tst-open', !open); }
else if (a === 'voorkeuren') toon('heropend');
else if (a === 'w-overzicht') toon('overzicht');
else if (a === 'intrekken') { dl({ event: 'consent-studio__user-interacted__btn__revoke' }); keuze('f', 'intrekken'); }
else if (a === 'kopie') { try { navigator.clipboard.writeText(cookie.id); b.setAttribute('aria-label', tx('gekopieerd')); } catch (x) {} }
} catch (x) { fout(x); }
}
function toets(e) {
if (!venster || venster.hidden) return;
if (e.key === 'Escape') {
e.preventDefault();
if (vorm === 'overzicht') { if (terug) toon(terug); else sluit(); }
else if (vorm === 'heropend') sluit();
else { dl({ event: 'consent-studio__user-interacted__btn__reject-all' }); keuze('f', 'escape'); }
} else if (e.key === 'Tab') {
var f = venster.querySelectorAll('button,a[href],input:not([disabled])'), eerste = f[0], laatste = f[f.length - 1];
if (!f.length) return;
if (e.shiftKey && (D.activeElement === eerste || D.activeElement === venster)) { e.preventDefault(); laatste.focus(); }
else if (!e.shiftKey && D.activeElement === laatste) { e.preventDefault(); eerste.focus(); }
}
}
function laadShopify(cb) {
var Sh = W.Shopify, k = false;
if (!Sh || !Sh.loadFeatures) return cb(null);
if (Sh.customerPrivacy && Sh.customerPrivacy.getRegion) return cb(Sh.customerPrivacy);
function klaar() { if (!k) { k = true; cb(Sh.customerPrivacy && Sh.customerPrivacy.getRegion ? Sh.customerPrivacy : null); } }
try { Sh.loadFeatures([{ name: 'consent-tracking-api', version: '0.1' }], klaar); } catch (e) { klaar(); }
setTimeout(klaar, 4000);
}
function aan(P, buiten) {
try { var st = D.createElement('style'); st.textContent = '#shopify-pc__banner,#shopify-pc__prefs{display:none!important}'; D.head.appendChild(st); } catch (e) {}
cookie = leesCookie();
var oud = cookie && I.opnieuw_vragen_vanaf && (cookie.b !== I.banner_versie || cookie.l !== I.lijst_versie) && cookie.t < I.opnieuw_vragen_vanaf;
var z = I.google_zonder_ja || {}; gtag('set', 'ads_data_redaction', (land in z ? z[land] : z.standaard) === false);
if (cookie && !oud) { signalen(cookie.c, 'laad'); maakWidget(); return; }
if (buiten) { signalen('fam', 'buiten'); return; }
if (!cookie) {
var cv = P && P.currentVisitorConsent && P.currentVisitorConsent();
if (cv && /^(yes|no)$/.test(cv.analytics) && /^(yes|no)$/.test(cv.marketing)) { keuze('f' + (cv.analytics === 'yes' ? 'a' : '') + (cv.marketing === 'yes' ? 'm' : ''), 'herstel', 'herstel'); return; }
if (navigator.globalPrivacyControl === true) { keuze('f', 'gpc'); return; }
}
toon('banner');
}
function schaduw(P, buiten) {
tel('schaduw_bezoek'); tel(buiten ? 'schaduw_buiten_eu' : 'schaduw_stand_' + S);
var cv = P && P.currentVisitorConsent && P.currentVisitorConsent(), weet = !!(cv && /^(yes|no)$/.test(cv.analytics)), n = 0;
var iv = setInterval(function () {
n++; var b = D.querySelector('.cs .cs-banner');
if (b) { var r = b.getBoundingClientRect(); if (r.width > 0 && r.height > 0 && parseFloat(getComputedStyle(b).opacity) > 0.5) { clearInterval(iv); tel('schaduw_cs_getoond'); if (weet) tel('schaduw_cs_opnieuw_terwijl_shopify_weet'); } }
if (n > 40) clearInterval(iv);
}, 500);
W.addEventListener('consent-studio__updated', function (e) {
try {
var d = e.detail || {}; if (d.source !== 'interactive') return;
var cs = d.categories || [], a = cs.indexOf('analytics') > -1, m = cs.indexOf('marketing') > -1;
register({ id: uuid(), winkel: I.winkel, domein: host, land: land || null, taal: I.taal || null, pagina: location.pathname, stand: S, f: true, a: a, m: m, via: a && m ? 'alles' : (a || m) ? 'selectie' : 'kruisje', vorige_id: null, bv: I.banner_versie || null, lv: I.lijst_versie || null, bron: 'schaduw', test: !!I.test });
} catch (x) { fout(x); }
});
}
function start() {
host = location.hostname.replace(/^www\./, ''); stand = (I.domeinen && I.domeinen[host]) || 'uit';
if (stand !== 'aan' && stand !== 'schaduw') return;
verzend();
laadShopify(function (P) {
try {
land = String((P && P.getRegion && P.getRegion()) || '').slice(0, 2).toUpperCase();
if (I.test) { var q = location.search.match(/[?&]toestemming_land=([A-Za-z]{2})/); if (q) land = q[1].toUpperCase(); }
var moet = !P || !P.shouldShowBanner || P.shouldShowBanner() !== false;
S = (I.standen && (I.standen[land] || I.standen.standaard)) || 'weigerknop';
var buiten = !moet && !!land && EU.indexOf(land) < 0;
if (stand === 'schaduw') schaduw(P, buiten); else aan(P, false);
} catch (e) { fout(e); }
});
}
W.Toestemming = {
open: function () { if (stand === 'aan') toon(cookie ? 'heropend' : 'banner'); },
overzicht: function () { if (stand === 'aan') toon('overzicht'); },
intrekken: function () { if (stand === 'aan' && cookie) keuze('f', 'intrekken'); },
isOpen: function () { return !!(venster && !venster.hidden); },
keuze: function () { return cookie ? { functioneel: true, analytics: cookie.c.indexOf('a') > -1, marketing: cookie.c.indexOf('m') > -1, id: cookie.id, t: cookie.t } : null; },
stand: function () { return { domein: stand, land: land, vorm: S }; }
};
try { if (D.readyState === 'loading') D.addEventListener('DOMContentLoaded', start); else start(); } catch (e) { fout(e); }
})();